<!--
DdPortalPartsNotification
-->
<template>
<div>
  <!-- 件数取得の為のバインド定義 -->
  <div style="display:none">{{isNewInfo}}</div>

  <div id="information" class="pt-5" />
  <div v-if="!userSettings || userSettings.userNotificationFlg">
    <v-card style="border-radius:10px">
      <v-card-text class="pb-2">
        <v-row no-gutters class="mx-3 px-2">
          <div id="admin-notification" class="admin-notification"/>
          <div class="mt-5">
            <span style="color: #000000;font-size:X-large;font-weight:bold;">社内向けのお知らせ</span>
            <v-icon color="green" class="blinking" style="bottom:4px" v-if="isNewInfo1" large>mdi-new-box</v-icon>
          </div>
        </v-row>
        <v-row no-gutters>
          <v-col :cols="12" class="px-5">
          <hr
            style="padding-top: 0px !important; padding-bottom: 0px !important; margin-top: 4px !important; margin-bottom: 0px !important;"
            color="#00ffdd"
          >
          </v-col>
        </v-row>
        <v-row no-gutters class="ma-0 px-1 pt-1 pr-6">
          <div v-if="filteredOshiraseToWithInCompanyRows.length > 0">
            <v-col :cols="12" class="px-1 pt-0" v-for="item in filteredOshiraseToWithInCompanyRows" v-bind:key="item.id">
              <v-row no-gutters class="px-2 mt-1">
                <span style="width:80px;color:#1F2B38;">
                  <v-chip class="ma-0" pill small dark dense :color="item.oshiraseSbtColor">
                    <span style="width:50px;text-align:center;">{{item.oshiraseSbtNm}}</span>
                  </v-chip>
                </span>
                <span style="width:100px;color:#1F2B38;" class="pt-1">
                  <span>{{item.tekiyoStartYmdDisp}}</span>
                </span>
                <span class="pt-1">
                  <div>
                    <span style="color:#1F2B38; white-space:pre-wrap;">{{item.oshiraseShosai}}</span>
                  </div>
                  <div v-if="![undefined, null, ''].includes(item.linkUrl)">
                    <a style="color:blue !important;">{{item.linkUrl}}</a>
                  </div>
                </span>
              </v-row>
            </v-col>
          </div>
          <div v-else>
            <v-col :cols="12" class="px-1 pt-0">
              <div v-if="mstSharyoShakenList.length === 0"><v-icon>mdi-square-small</v-icon>新しいお知らせはありません。</div>
            </v-col>
          </div>
        </v-row>

        <br />

        <div v-if="userSettings && (userSettings.sharyoNotificationFlg || userSettings.menkyoNotificationFlg)">
          <v-row no-gutters>
            <!----------------------------------------------------------------------------------------------------
              車検
              ---------------------------------------------------------------------------------------------------->
            <v-col :cols="6" v-if="!userSettings || userSettings.sharyoNotificationFlg">
              <v-row no-gutters justify="center">
                <v-card width="95%" style="border-radius:10px">
                  <v-card-text>
                    <div id="car-notification" class="car-notification"/>
                    <div class="mx-2 mt-2 pt-2 card-title-notification2">
                      車両のお知らせ
                    </div>
                    <div v-if="mstSharyoShakenList.length === 0"><v-icon>mdi-square-small</v-icon>新しいお知らせはありません。</div>
                    <div v-else>
                      <v-row
                        class="mt-2"
                        no-gutters
                        v-for="sub in mstSharyoShakenList"
                        :key="sub.id"
                      >
                        <v-col :cols="12" class="px-1">
                          <v-icon>mdi-square-small</v-icon>
                          車両{{ sub.jidoshaHyojiNm }}（{{ sub.sharyoCd }}）の車検時期（{{ sub.nextShakenYmdDisp }}）にご注意ください。
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </v-row>
            </v-col>
            <!----------------------------------------------------------------------------------------------------
              免許
              ---------------------------------------------------------------------------------------------------->
            <v-col :cols="6" v-if="!userSettings || userSettings.menkyoNotificationFlg">
              <v-row no-gutters justify="center">
                <v-card width="95%" style="border-radius:10px">
                  <v-card-text>
                    <div id="licence-notification" class="licence-notification"/>
                    <div class="mx-2 mt-2 pt-2 card-title-notification2">
                      免許更新のお知らせ
                    </div>
                    <div v-if="mstMenkyoshoList.length === 0"><v-icon>mdi-square-small</v-icon>新しいお知らせはありません。</div>
                    <div v-else>
                      <v-row
                        class="mt-2"
                        no-gutters
                        v-for="sub in mstMenkyoshoList"
                        :key="sub.id"
                      >
                        <div class="px-1">
                          <v-icon>mdi-square-small</v-icon>
                          {{ sub.jininNm }}さん（{{ sub.jininCd }}）の免許更新期限（{{ sub.yukokigenDisp }}）にご注意ください。
                        </div>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>

  <!----------------------------------------------------------------------------------------------------
    システムからのお知らせ
    ---------------------------------------------------------------------------------------------------->
  <div class="pt-5" />
  <div id="system-notification" class="system-notification"/>
  <v-card style="border-radius:10px">
    <v-card-text class="pb-2">
      <v-row no-gutters class="mx-3 px-2">
        <div class="mt-5">
          <span style="color: #000000;font-size:X-large;font-weight:bold;">システムからのお知らせ</span>
          <v-icon color="green" class="blinking" style="bottom:4px" v-if="isNewInfo2" large>mdi-new-box</v-icon>
        </div>
      </v-row>
      <v-row no-gutters>
        <v-col :cols="12" class="px-5">
        <hr
          style="padding-top: 0px !important; padding-bottom: 0px !important; margin-top: 4px !important; margin-bottom: 0px !important;"
          color="#00ffdd"
        >
        </v-col>
      </v-row>
      <div v-if="filteredOshiraseFromSystemRows.length > 0">
        <v-row no-gutters class="ma-0 px-1 pt-1 pr-6">
          <v-col :cols="12" class="px-1 pt-0" v-for="item in filteredOshiraseFromSystemRows" v-bind:key="item.id">
            <v-row no-gutters class="px-2 mt-1">
              <span style="width:80px;color:#1F2B38;">
                <v-chip class="ma-0" pill small dark dense :color="item.oshiraseSbtColor">
                  <span style="width:50px;text-align:center;">{{item.oshiraseSbtNm}}</span>
                </v-chip>
              </span>
              <span style="width:100px;color:#1F2B38;" class="pt-1">
                <span>{{item.tekiyoStartYmdDisp}}</span>
              </span>
              <span class="pt-1">
                <div>
                  <span style="color:#1F2B38; white-space:pre-wrap;">{{item.oshiraseShosai}}</span>
                </div>
                <div v-if="![undefined, null, ''].includes(item.linkUrl)">
                  <a style="color:blue !important;">{{item.linkUrl}}</a>
                </div>
              </span>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-col :cols="12" class="px-1 pt-0">
          <div v-if="mstSharyoShakenList.length === 0"><v-icon>mdi-square-small</v-icon>新しいお知らせはありません。</div>
        </v-col>
      </div>
    </v-card-text>
  </v-card>

  <br />

</div>
</template>

<script>
// ************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************
// import controls from '@/rahmen/controls'
// import effects from '@/rahmen/utils/effects'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'

import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'

import { mapGetters } from 'vuex'

export default {
  name: 'DdPpNotification',
  mixins: [flowMixin],
  components: {
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean
  },
  data: () => ({
    oshiraseRows: [],
    isNewInfo1: false,
    isNewInfo2: false
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      userId: 'users/userId',
      currentKaishaCode: 'users/currentKaishaCode',
      kengenGroupCd: 'users/kengenGroupCd',
      jininList: 'DDMasters/mstJinin',
      menkyoshoList: 'DDMasters/mstMenkyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      userSettings: 'DDMasters/mstUserSettings'
    }),
    // 社内向けお知らせ
    filteredOshiraseToWithInCompanyRows () {
      const target = filter.dateFormatter(date.getCurrentDate())
      const self = this
      const rows = this.oshiraseRows.map((elem) => {
        var kbnm01 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM01', elem.title)
        var kbnm00 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM00', elem.hasseimotoKbn)

        elem.oshiraseSbtNm = kbnm01 ? kbnm01.codeNm : ''
        elem.oshiraseSbtColor = kbnm01 ? kbnm01.komoku1 : 'white'
        elem.hasseimotoKbnNm = kbnm00 ? kbnm00.codeNm : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.kaishaCd === self.currentKaishaCode && elem.hasseimotoKbn === '20' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.delFlg === false
      }).sort((elem1, elem2) => {
        if (elem1.tekiyoStartYmdDisp > elem2.tekiyoStartYmdDisp) { return 1 }
        if (elem1.tekiyoStartYmdDisp === elem2.tekiyoStartYmdDisp) { return 0 }
        return -1
      })
      return rows
    },
    // システムからのお知らせ
    filteredOshiraseFromSystemRows () {
      const target = filter.dateFormatter(date.getCurrentDate())
      const self = this
      const rows = this.oshiraseRows.map((elem) => {
        var kbnm01 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM01', elem.title)
        var kbnm00 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM00', elem.hasseimotoKbn)

        elem.oshiraseSbtNm = kbnm01 ? kbnm01.codeNm : ''
        elem.oshiraseSbtColor = kbnm01 ? kbnm01.komoku1 : 'white'
        elem.hasseimotoKbnNm = kbnm00 ? kbnm00.codeNm : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.kaishaCd === self.currentKaishaCode && elem.hasseimotoKbn === '10' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.delFlg === false
      }).sort((elem1, elem2) => {
        if (elem1.tekiyoStartYmdDisp > elem2.tekiyoStartYmdDisp) { return 1 }
        if (elem1.tekiyoStartYmdDisp === elem2.tekiyoStartYmdDisp) { return 0 }
        return -1
      })
      return rows
    },
    // オイル交換
    mstSharyoOilList () {
      const target = filter.dateFormatter(this.getAfterDay(30))
      return this.sharyoList.map((m) => {
        m.nextOilYmdDisp = filter.dateFormatter(m.nextOilYmd)
        return m
      }).filter((m) => {
        return m.nextOilYmdDisp < target
      })
    },
    isNewInfo3 () {
      if (this.mstSharyoOilList.length > 0) {
        return true
      } else {
        return false
      }
    },
    // 車検
    mstSharyoShakenList () {
      const target = filter.dateFormatter(this.getAfterDay(30))
      return this.sharyoList.map((m) => {
        m.nextShakenYmdDisp = filter.dateFormatter(m.nextShakenYmd)
        return m
      }).filter((m) => {
        return m.nextShakenYmdDisp < target
      })
    },
    isNewInfo4 () {
      if (this.mstSharyoShakenList.length > 0) {
        return true
      } else {
        return false
      }
    },
    // 免許更新
    mstMenkyoshoList () {
      const target = filter.dateFormatter(this.getAfterDay(30))
      return this.menkyoshoList.map((m) => {
        m.yukokigenDisp = filter.dateFormatter(m.yukokigen)
        m.jininNm = ''
        const ret = this.jininList.filter(function (t) {
          return t.jininCd === m.jininCd && t.tekiyoStartYmdString <= target && t.tekiyoEndYmdString >= target
        })
        if (ret.length > 0 && ret[0].jininNmSei !== '') {
          m.jininNm = ret[0].jininNmSei
        }
        return m
      }).filter((m) => {
        return m.yukokigenDisp < target
      })
    },
    isNewInfo5 () {
      if (this.mstMenkyoshoList.length > 0) {
        return true
      } else {
        return false
      }
    },
    // お知らせ件数
    isNewInfo () {
      var notificationCount = 0
      if (!this.userSettings || this.userSettings.userNotificationFlg) {
        notificationCount = notificationCount + this.filteredOshiraseToWithInCompanyRows.length
        this.$store.dispatch('system/setAdminNotificationCount', this.filteredOshiraseToWithInCompanyRows.length)
      }
      if (!this.userSettings || (this.userSettings.userNotificationFlg && this.userSettings.sharyoNotificationFlg)) {
        notificationCount = notificationCount + this.mstSharyoOilList.length + this.mstSharyoShakenList.length
        this.$store.dispatch('system/setCarNotificationCount', this.mstSharyoOilList.length + this.mstSharyoShakenList.length)
      }
      if (!this.userSettings || (this.userSettings.userNotificationFlg && this.userSettings.menkyoNotificationFlg)) {
        notificationCount = notificationCount + this.mstMenkyoshoList.length
        this.$store.dispatch('system/setLicenceNotificationCount', this.mstMenkyoshoList.length)
      }
      notificationCount = notificationCount + this.filteredOshiraseFromSystemRows.length
      this.$store.dispatch('system/setSystemNotificationCount', this.filteredOshiraseFromSystemRows.length)

      this.$store.dispatch('system/setNotificationCount', notificationCount)
      return notificationCount > 0
    }
  },
  methods: {
    initialize: function (e) {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['mstjinin', 'msyskubun', 'mstmenkyosho', 'vwcmstsharyo'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('EtcRiyouJohoList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('EtcRiyouJohoList.savedInputRestorePromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('EtcRiyouJohoList.researchPromise', c)
          return new Promise(resolve => {
            self.getOshiraseRows()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            self.getOshiraseRows()
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    getOshiraseRows: function (e) {
      this.oshiraseRows = []
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.get('/api/v1/MsysMenuOshirase/GetAll', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.oshiraseRows = data.payload
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    searchValidate: function () {
      return true
    },

    isLatest: function (targetDate) {
      // １週間前の日付を取得
      var xDate = this.get1WeekAgoDay().replaceAll('/', '')

      // 日付比較
      var tDate = targetDate.substr(0, 10).replaceAll('-', '')
      if (xDate < tDate) {
        return true
      }
      return false
    },
    get1WeekAgoDay: function () {
      var date = new Date()
      date.setDate(date.getDate() - 7)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    },
    getAfterDay: function (num) {
      var date = new Date()
      date.setDate(date.getDate() + num)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    }
  }
}
</script>
<style scoped>
.text-h5 {
    padding: .1em .5em;
    margin-top: 6px;
    border-left: 6px solid rgb(47, 117, 181);
}
.no-under-line /deep/ {
    text-decoration: none;
}
.menu-description {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.card-title {
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 4px;
  padding-right: 4px;
  background-color: rgb(165, 214, 240);
}
.card-title-notification {
  height:40px;
  background-color: #ffffff;
  border: none;
  border-radius: 30px;
  text-align:left;
  color:#000000;
  font-size:X-large;
  font-weight:bold;
}
.card-title-notification2 {
  height:40px;
  background-color: #add8e6;
  border: none;
  border-radius: 20px;
  text-align:center;
  color:#000000;
  font-size:large;
  font-weight:bold;
}
</style>
